export default __webpack_public_path__ + "static/media/stocks-icon.4421ad12.svg";